import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
// @mui
import { Box, Fab } from "@mui/material";
// hooks
import useResponsive from "../../hooks/useResponsive";
// components
import { useSettingsContext } from "../../components/settings";
//
import Main from "./Main";
import Header from "./header";
import NavMini from "./nav/NavMini";
import NavVertical from "./nav/NavVertical";
import { useBoolean } from "src/hooks/useBoolean";
import Iconify from "src/components/iconify";
import ChatContainer from "src/common/aiChat/chatContainer";

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { themeLayout } = useSettingsContext();

  const chatOpen = useBoolean();

  // Restore background scrolling when chat is closed
  useEffect(() => {
    if (!chatOpen.value) {
      document.body.style.overflow = "auto";
    }
  }, [chatOpen.value]);

  const isDesktop = useResponsive("up", "lg");

  const [open, setOpen] = useState(false);

  const isNavMini = themeLayout === "mini";

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderNavVertical = (
    <NavVertical openNav={open} onCloseNav={handleClose} />
  );

  if (isNavMini) {
    return (
      <>
        <Header onOpenNav={handleOpen} />

        <Box
          sx={{
            display: { lg: "flex" },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? <NavMini /> : renderNavVertical}

          <Main>
            <Outlet />
          </Main>
        </Box>
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: "flex" },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </Box>

      {/* AI Chat FAB Button */}
      <Fab
        color="primary"
        aria-label="Edit space details"
        // size="small"
        variant="softExtended"
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1000,
          textTransform: "none",
        }}
        onClick={chatOpen.onTrue}
        style={{ gap: "8px" }}
      >
        <Iconify icon="solar:chat-round-dots-bold" width={24} />
        AI assistant
      </Fab>

      {/* AI Chat Container - for future implementation */}
      {chatOpen.value && <ChatContainer onCloseCompose={chatOpen.onFalse} />}
    </>
  );
}
